import { Button, Col, Flex, Row, Spin, Table, Typography } from "antd";
import React from "react";
import ZCard from "../../Card/Index";
import CustomTypography from "../../common/CustomTypography";
import styles from './cashflow.module.scss'
import { useSelector } from "react-redux";
import { TabsEnum } from "../../../utils/Enum/ReportTabsEnum";
import CustomAmountText from "../../common/CustomAmountText";
import { CURRENCY } from "../../../utils/ConstantData";
import { CurrencyFormatWithDecimal } from "../../../helper/CurrencyFormate";

const tableNames = ['Debit Transactions', 'Credit Transactions', 'Uses', 'Sources', 'Uses Monthly Analysis', 'Sources Monthly Analysis'];

const CashflowAnalysisPage = ({onClickTabChange = () => { }}) => {

    const { cashflowAnalysisDetails, cashflowAnalysisLoading: loading, cashflowAnalysisError: error } = useSelector(({ cashflowAnalysis }) => cashflowAnalysis);

    const topTransactionsColumns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Particulars',
            dataIndex: 'particular',
            key: 'particular',
        },
        {
            title: `Amount (${CURRENCY})`,
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            className: 'no-wrap-column',
            render: (text, record) => <CustomAmountText value={record.amount} /> || '-'
        },
        {
            title: "Category",
            dataIndex: "categories",
            key: "categories",
        },
    ];

    const topUsesSourcesColumns = [
        {
            title: 'Counterparty',
            dataIndex: 'counterparty',
            key: 'counterparty',
            render: (text) => text || '-',
        },
        {
            title: `Amount (${CURRENCY})`,
            dataIndex: 'totalTxnAmt',
            key: 'totalTxnAmt',
            align: 'right',
            className: 'no-wrap-column',
            render: (text) => <CustomAmountText value={text} /> || '-',
        },
        {
            title: 'Total Txn Count',
            dataIndex: 'totalTxnCount',
            key: 'totalTxnCount',
            render: (value, record, index) => {
                return (parseFloat(value) > 0 && cashflowAnalysisDetails.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
            },
        },
        {
            title: `Recurring Txn Amount (${CURRENCY})`,
            dataIndex: 'recurringTxnAmt',
            key: 'recurringTxnAmt',
            align: 'right',
            className: 'no-wrap-column',
            render: (value) => (
                <Typography.Text {...(value < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY)}</Typography.Text>
            )
            // ellipsis: true,
        },
        {
            title: 'Recurring Txn Count',
            dataIndex: 'recurringTxnCount',
            key: 'recurringTxnCount',
            render: (value, record, index) => {
                return (parseFloat(value) > 0 && cashflowAnalysisDetails.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
            },
        },
        {
            title: 'Primary Txn Category',
            dataIndex: 'primaryTxnCategory',
            key: 'primaryTxnCategory',
            render: (value, record, index) => {
                return (parseFloat(value) > 0 && cashflowAnalysisDetails.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
            },
        },
    ];

    // const topUsesSourcesMonthlyAnalysisColumns = [
    //     ...topUsesSourcesColumns,
    // ];

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
                <Spin size="large" />
            </div>
        )
    }

    if (error) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", flexDirection: "column" }}>
                <CustomTypography style={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px", color: "#000000E0", fontFamily: "Satoshi" }}>Error fetching data</CustomTypography>
                <CustomTypography type={"paragraph"} style={{ fontSize: "10px", fontWeight: 300, lineHeight: "16px", color: "#000000E0", fontFamily: "Satoshi" }}>{error}</CustomTypography>
            </div>
        )
    }

    return <>
        <Row gutter={[16, 16]}>
            <Col span={12}>
                <ZCard title={`Top ${cashflowAnalysisDetails?.cashflowAnalysis?.topDebitTxns.length || ""} ${tableNames[0]}`} >
                    <Table pagination={false} columns={topTransactionsColumns} dataSource={cashflowAnalysisDetails?.cashflowAnalysis?.topDebitTxns} scroll={{x: 1000}} />
                </ZCard>
            </Col>
            <Col span={12}>
                <ZCard title={`Top ${cashflowAnalysisDetails?.cashflowAnalysis?.topCreditTxns.length || ""} ${tableNames[1]}`} >
                    <Table pagination={false} columns={topTransactionsColumns} dataSource={cashflowAnalysisDetails?.cashflowAnalysis?.topCreditTxns} scroll={{x: 1000}} />
                </ZCard>
            </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-16">
            <Col span={12}>
                <ZCard title={`Top ${cashflowAnalysisDetails?.cashflowAnalysis?.topUsers.length || ""} ${tableNames[2]}`} >
                    <Table pagination={false} columns={topUsesSourcesColumns} dataSource={cashflowAnalysisDetails?.cashflowAnalysis?.topUsers} scroll={{x: 1000}}/>
                </ZCard>
            </Col>
            <Col span={12}>
                <ZCard title={`Top ${cashflowAnalysisDetails?.cashflowAnalysis?.topSources.length || ""} ${tableNames[3]}`} >
                    <Table pagination={false} columns={topUsesSourcesColumns} dataSource={cashflowAnalysisDetails?.cashflowAnalysis?.topSources} scroll={{x: 1000}} />
                </ZCard>
            </Col>
        </Row>
        <Row gutter={[16, 16]} className="pt-16">
            <Col span={12}>
                <ZCard title={`${`Top 5`} ${tableNames[4]}`} >
                    {
                        cashflowAnalysisDetails?.cashflowAnalysis?.topUsersMonthlyAnalysis.map((item, index) => (
                            <CashflowUserSourcesMonthlyTable columns={topUsesSourcesColumns} dataSource={item.transactions} month={item.month} scroll={{x: 1000}}/>
                        ))
                    }
                </ZCard>

            </Col>
            <Col span={12}>
                <ZCard title={`${`Top 5`} ${tableNames[5]}`} >
                    {
                        cashflowAnalysisDetails?.cashflowAnalysis?.topSourcesMonthlyAnalysis.map((item, index) => (
                            <CashflowUserSourcesMonthlyTable columns={topUsesSourcesColumns} dataSource={item.transactions} month={item.month} scroll={{x: 1000}}/>
                        ))
                    }
                </ZCard>
            </Col>
        </Row>
    </>;
};

const CashflowUserSourcesMonthlyTable = ({ columns = [], dataSource = [], month = '' }) => {
    return (
        <Flex vertical component={"div"}>
            <Flex justify="center" align="center" component={"div"} style={{ minHeight: "38px", background: "#00000026", border: "1px solid #F0F0F0" }}>
                <CustomTypography className={styles.tableMonthlyName}>{month}</CustomTypography>
            </Flex>
            <Table tableLayout="fixed" className={styles.noBorderRadiusTable} pagination={false} columns={columns} dataSource={dataSource} scroll={{x: 1000}}/>
        </Flex>
    )
}

export default CashflowAnalysisPage;
